(function () {
    "use strict";
    window.tinycolor = window.tinycolor || {};
    function colorSelectorDirective($translate) {
        return {
            restrict: "A",
            require: "ngModel",
            templateUrl: "colorSelector.tpl",
            scope: {
                ngModel: "=",
                palette: "="
            },
            link: function (scope, _element, _attrs, ctrl) {
                scope.format = "rgb";
                if (scope.ngModel === undefined)
                    scope.ngModel = {};
                scope.colorChange = function (color) {
                    scope.ngModel.color = color.toHexString();
                    loadColorFields();
                    scope.ngModel.textColor = window.tinycolor.mostReadable(scope.ngModel.color, ["#fff", "#000"]).toHexString();
                    scope.$apply();
                };
                scope.ngModelColorOptions = {
                    preferredFormat: "hex",
                    change: scope.colorChange,
                    showInput: false,
                    showPalette: false,
                    showSelectionPalette: false,
                    chooseText: $translate.instant("common.select"),
                    cancelText: $translate.instant("common.cancel")
                };
                function loadColorFields() {
                    scope.ngModel.rgb = window.tinycolor(scope.ngModel.color).toRgb();
                    scope.ngModel.hsl = window.tinycolor(scope.ngModel.color).toHsl();
                    scope.ngModel.hsl.h = scope.ngModel.hsl.h.toFixed(2);
                    scope.ngModel.hsl.s = scope.ngModel.hsl.s.toFixed(2);
                    scope.ngModel.hsl.l = scope.ngModel.hsl.l.toFixed(2);
                    scope.ngModel.hsv = window.tinycolor(scope.ngModel.color).toHsv();
                    scope.ngModel.hsv.h = scope.ngModel.hsv.h.toFixed(2);
                    scope.ngModel.hsv.s = scope.ngModel.hsv.s.toFixed(2);
                    scope.ngModel.hsv.v = scope.ngModel.hsv.v.toFixed(2);
                    scope.ngModel.hex = window.tinycolor(scope.ngModel.color).toHexString();
                    if (!scope.ngModel.textColor || scope.ngModel.textColor.trim === "")
                        scope.ngModel.textColor = window.tinycolor.mostReadable(scope.ngModel.color, ["#fff", "#000"]).toHexString();
                }
                loadColorFields();
                scope.updateColor = function () {
                    switch (scope.format) {
                        case "rgb":
                            scope.ngModel.color = window.tinycolor(scope.ngModel.rgb).toHexString();
                            break;
                        case "hsl":
                            scope.ngModel.color = window.tinycolor(scope.ngModel.hsl).toHexString();
                            break;
                        case "hsv":
                            scope.ngModel.color = window.tinycolor(scope.ngModel.hsv).toHexString();
                            break;
                        case "hex":
                            scope.ngModel.color = window.tinycolor(scope.ngModel.hex).toHexString();
                            break;
                    }
                    scope.ngModel.textColor = window.tinycolor.mostReadable(scope.ngModel.color, ["#fff", "#000"]).toHexString();
                    loadColorFields();
                };
                scope.$watch("palette", function (value) {
                    if (value && value.length > 0) {
                        scope.ngModelColorOptions.palette = value;
                        scope.ngModelColorOptions.showPalette = true;
                    }
                });
                ctrl.$formatters.push(function () {
                    loadColorFields();
                });
            }
        };
    }
    colorSelectorDirective.$inject = ["$translate"];
    angular
        .module("skillBuilderSaaS")
        .directive("colorSelector", colorSelectorDirective);
}());
